import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import { Server } from 'src/server/server';
import './SitePage.css'
import './JoinCommunityPage.css'
import { BsFillPeopleFill } from 'react-icons/bs';

interface JoinCommunityPageState {
  loading: boolean;
  communities: any[]
}

class JoinCommunityPage extends React.Component<{}, JoinCommunityPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true,
      communities: []
    }
  }

  componentDidMount(): void {
    this.findCommunities();
  }

  async findCommunities() {
    let response = await Server.public.findCommunities({});
    if(!response.success)
      return;

    let userCommunities = Server.user.getCommunities();

    let communities = [];
    for(let i = 0; i < response.communities.length; i++) {
      let uc = userCommunities.find(c => c.id == response.communities[i].id);
      if(!uc)
        communities.push(response.communities[i]);
    }

    this.setState({communities, loading: false})
  }

  onVisit(community:any) {
    let email = window.localStorage.getItem('RefreshEmail');
    let token = window.localStorage.getItem('RefreshToken');
    let auth = (email && token) ? `/login?${email}&${token}` : '';

    let url = window.location.host;
    if(url.indexOf('www') == 0)
      url = url.replace('www', community.slug)
    else
      url = community.slug + '.' + url;

    url = window.location.protocol + '//' + url + auth;

    window.open(url, '_blank');
  }

  renderCommunities() {
    let divs = [];
    for(let i = 0; i < this.state.communities.length; i++) {
      let community = this.state.communities[i];

      divs.push(
        <div key={i} className="join-page-community-row" onClick={()=>this.onVisit(community)}>
          <img style={{width: '40px'}} src={community.icon}/>
          <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <div>{community.name}</div>
              <div>{community.members}&nbsp;&nbsp;<BsFillPeopleFill style={{fontSize: '1.1em', marginBottom: '-3px'}} /></div>
            </div>
            <div style={{fontSize: '0.9em', marginTop: '2px', marginRight: '35px'}}>{community.description}</div>
          </div>
        </div>
      )
    }

    return (
      <div className="site-page-panel" style={{padding: '15px'}}>
        {divs.length == 0 ? 'No communities available.' : divs}
      </div>
    )
  }

  render() {
    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div style={{textAlign: 'center', margin: '0px 0px 20px 0px'}}>
            Select a community to join.
          </div>
          <div className="site-page-column">
            {this.state.loading ? <div className="site-page-panel">Loading...</div> : this.renderCommunities()}
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default JoinCommunityPage;